import { FeedbackService } from '@/services/feedback/feedback-service';
import { FeedbackCommandContribution } from '@/services/feedback/impls/feedback-command-contribution';
import { FeedbackServiceImpl } from '@/services/feedback/impls/feedback-service';
import { createRequestFeedbackService } from '@/services/feedback/impls/request-feedback-service';
import { RequestFeedbackService } from '@/services/feedback/request-feedback-service';
import { CommandContribution } from '@patsnap/tahiti-core';
import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';

export const feedbackModule = new ContainerModule((bind) => {
    bind(FeedbackService).to(FeedbackServiceImpl);
    bind(RequestFeedbackService).toDynamicValue(createRequestFeedbackService());
    bind(CommandContribution).to(FeedbackCommandContribution);
});
